<script setup lang="ts">
import { TooltipTrigger as RadixTooltipTrigger, type TooltipTriggerProps } from 'radix-vue'

const props = defineProps<TooltipTriggerProps>()
</script>

<template>
  <RadixTooltipTrigger v-bind="props">
    <slot />
  </RadixTooltipTrigger>
</template>
